const injectDriver = (liveDOM) => {
  const script = liveDOM.createElement('script');
  script.setAttribute('data-driver-connector', true);
  script.innerHTML = `window.parent.__driver.connectLiveDocument(document);`;
  liveDOM.body.insertAdjacentElement('beforeend', script);
};

export default injectDriver;
